export default __webpack_public_path__ + "static/media/Homeo1.b92f6a0a.pdf";